export default "__VITE_PUBLIC_ASSET__69e3fcc2__"